<template>
  <div>
    <Login
      v-if="show === 'login'"
      :confirmation-request="confirmationRequest"
      :enable-passwordless-email="false"
      :enable-passwordless-sms="true"
    />
    <PasswordReset
      v-if="show === 'recover'"
    />
    <Register
      v-if="show === 'register'"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Login from "./Login.vue";
import Register from "./Register.vue";
import "../../style/forms.css";
import PasswordReset from "./PasswordReset.vue";

@Component({
  components: {
    PasswordReset,
    Login,
    Register
  }
})
export default class Authenticate extends Vue {
  show = "login";
  confirmationRequest: ConfirmationRequest = {} as ConfirmationRequest;
  removeRouterGuardHandler?: Function;

  created(): void {
    if (this.$route && this.$route.params.action) {
      this.show = this.$route.params.action;
    }

    this.removeRouterGuardHandler = this.$router.beforeEach((to, from, next) => {
      switch (to.path) {
        case '/account/register':
          this.show = 'register';
          break;
        case '/account/login':
          this.show = 'login';
          break;
        case '/account/recover':
          this.show = 'recover';
          break;
        default:
          next();
          return;
      }

      next(false);
    });
  }

  destroyed(): void {
    if (this.removeRouterGuardHandler) {
      this.removeRouterGuardHandler();
    }
  }
}
</script>

<style scoped>

</style>
